import {ApprovalStatus} from "@/graphql/graphql.ts";
import {Chip} from "@mui/material";
import {useMemo} from "react";

const ApprovalStatusTitle: Record<ApprovalStatus, string> = {
  [ApprovalStatus.InReview]: "承認待ち",
  [ApprovalStatus.Approved]: "承認済",
  [ApprovalStatus.Rejected]: "却下",
  [ApprovalStatus.Draft]: "下書き"
};

export function ApprovalStatusChip({status}: { status: ApprovalStatus }) {
  const color = useMemo(() => {
    switch (status) {
      case ApprovalStatus.InReview:
        return "warning";
      case ApprovalStatus.Approved:
        return "success";
      case ApprovalStatus.Rejected:
        return "error";
      default:
        return "default";
    }
  }, [status])
  
  return <Chip color={color} label={ApprovalStatusTitle[status]}/>
}